import { Union, Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { unit_type, union_type, list_type, record_type, anonRecord_type, class_type, option_type, string_type, bool_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { Required_AsString_Z721C83C5, SveaDry_Read_load, Required_AsString_Z524259C1, templateUrl, SveaDry_sendAsync, SveaDry_Read_unit, SveaDry_ResponseContainer__get_AsString, SveaDry_ResponseContainer__get_StatusCode, SveaDry_Write_array, SveaDry_Write_optional, Unformat_date, SveaDry_Write_decimal, SveaDry_Read_decimal, Format_date, SveaDry_Write_int64, SveaDry_Write_string, SveaDry_Read_array, SveaDry_Write_boolean, SveaDry_Write_object, Format_dateTime, SveaDry_Read_int64, SveaDry_Read_optional, SveaDry_Read_string, SveaDry_Read_boolean, SveaDry_Read_prop } from "./Library.js";
import { printf, toFail } from "../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { empty } from "../fable_modules/fable-library.3.7.20/List.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";

export class Models_AdmittanceAndFenixUser extends Record {
    constructor(AdmittanceUser, FenixUser) {
        super();
        this.AdmittanceUser = AdmittanceUser;
        this.FenixUser = FenixUser;
    }
}

export function Models_AdmittanceAndFenixUser$reflection() {
    return record_type("WebApi.Models.AdmittanceAndFenixUser", [], Models_AdmittanceAndFenixUser, () => [["AdmittanceUser", Models_AdmittanceUserDto$reflection()], ["FenixUser", anonRecord_type(["AdmittanceLoginEnabled", bool_type], ["Email", string_type], ["IpWhiteList", option_type(string_type)], ["IsApi", bool_type], ["MfaMethod", option_type(string_type)], ["Name", string_type], ["RequireIdsStepUp", bool_type], ["UserId", class_type("System.Int64")], ["Username", string_type])]]);
}

export class Models_AdmittanceFenixUser extends Record {
    constructor(AccountType, AdmittanceLoginEnabled, CreatedDateSwedish, Email, IpWhiteList, IsApi, LastLoginSwedish, MfaMethod, MobileNo, Name, RequireIdsStepUp, UserId, Username) {
        super();
        this.AccountType = AccountType;
        this.AdmittanceLoginEnabled = AdmittanceLoginEnabled;
        this.CreatedDateSwedish = CreatedDateSwedish;
        this.Email = Email;
        this.IpWhiteList = IpWhiteList;
        this.IsApi = IsApi;
        this.LastLoginSwedish = LastLoginSwedish;
        this.MfaMethod = MfaMethod;
        this.MobileNo = MobileNo;
        this.Name = Name;
        this.RequireIdsStepUp = RequireIdsStepUp;
        this.UserId = UserId;
        this.Username = Username;
    }
}

export function Models_AdmittanceFenixUser$reflection() {
    return record_type("WebApi.Models.AdmittanceFenixUser", [], Models_AdmittanceFenixUser, () => [["AccountType", option_type(string_type)], ["AdmittanceLoginEnabled", bool_type], ["CreatedDateSwedish", option_type(class_type("System.DateTimeOffset"))], ["Email", string_type], ["IpWhiteList", option_type(string_type)], ["IsApi", bool_type], ["LastLoginSwedish", option_type(class_type("System.DateTimeOffset"))], ["MfaMethod", option_type(string_type)], ["MobileNo", option_type(string_type)], ["Name", string_type], ["RequireIdsStepUp", bool_type], ["UserId", class_type("System.Int64")], ["Username", string_type]]);
}

export class Models_AdmittanceUser extends Record {
    constructor(AdmittanceEnabled, IsApi, Otp, RequireStepUp) {
        super();
        this.AdmittanceEnabled = AdmittanceEnabled;
        this.IsApi = IsApi;
        this.Otp = Otp;
        this.RequireStepUp = RequireStepUp;
    }
}

export function Models_AdmittanceUser$reflection() {
    return record_type("WebApi.Models.AdmittanceUser", [], Models_AdmittanceUser, () => [["AdmittanceEnabled", bool_type], ["IsApi", bool_type], ["Otp", bool_type], ["RequireStepUp", bool_type]]);
}

export class Models_AdmittanceUserDto extends Record {
    constructor(AccountType, CreatedTime, Email, LastLogin, LoginName, MobileNo, Name, PrincipalId, SecondaryRoles) {
        super();
        this.AccountType = AccountType;
        this.CreatedTime = CreatedTime;
        this.Email = Email;
        this.LastLogin = LastLogin;
        this.LoginName = LoginName;
        this.MobileNo = MobileNo;
        this.Name = Name;
        this.PrincipalId = PrincipalId;
        this.SecondaryRoles = SecondaryRoles;
    }
}

export function Models_AdmittanceUserDto$reflection() {
    return record_type("WebApi.Models.AdmittanceUserDto", [], Models_AdmittanceUserDto, () => [["AccountType", string_type], ["CreatedTime", option_type(string_type)], ["Email", string_type], ["LastLogin", option_type(string_type)], ["LoginName", string_type], ["MobileNo", option_type(string_type)], ["Name", string_type], ["PrincipalId", class_type("System.Int64")], ["SecondaryRoles", list_type(Models_SecondaryRoleDto$reflection())]]);
}

export class Models_BillingForClient extends Record {
    constructor(Acceptable, AcceptedBy, Batch, BatchId, CanRollback, ElapsedSeconds, Initiated, InitiatedBy, InitiatedUtc, InitiationKey, RollbackedBy, Started, StartedUtc, State, StatusCode, StatusDateTime, StatusMessage, StatusUtc, Type) {
        super();
        this.Acceptable = Acceptable;
        this.AcceptedBy = AcceptedBy;
        this.Batch = Batch;
        this.BatchId = BatchId;
        this.CanRollback = CanRollback;
        this.ElapsedSeconds = ElapsedSeconds;
        this.Initiated = Initiated;
        this.InitiatedBy = InitiatedBy;
        this.InitiatedUtc = InitiatedUtc;
        this.InitiationKey = InitiationKey;
        this.RollbackedBy = RollbackedBy;
        this.Started = Started;
        this.StartedUtc = StartedUtc;
        this.State = State;
        this.StatusCode = StatusCode;
        this.StatusDateTime = StatusDateTime;
        this.StatusMessage = StatusMessage;
        this.StatusUtc = StatusUtc;
        this.Type = Type;
    }
}

export function Models_BillingForClient$reflection() {
    return record_type("WebApi.Models.BillingForClient", [], Models_BillingForClient, () => [["Acceptable", bool_type], ["AcceptedBy", string_type], ["Batch", string_type], ["BatchId", class_type("System.Int64")], ["CanRollback", bool_type], ["ElapsedSeconds", option_type(class_type("System.Int64"))], ["Initiated", string_type], ["InitiatedBy", string_type], ["InitiatedUtc", string_type], ["InitiationKey", string_type], ["RollbackedBy", string_type], ["Started", option_type(string_type)], ["StartedUtc", option_type(string_type)], ["State", string_type], ["StatusCode", class_type("System.Int64")], ["StatusDateTime", option_type(string_type)], ["StatusMessage", string_type], ["StatusUtc", option_type(string_type)], ["Type", string_type]]);
}

export class Models_Body extends Record {
    constructor(Hidden, Name, ParentRoleId, RoleTypeName, RoleValue) {
        super();
        this.Hidden = Hidden;
        this.Name = Name;
        this.ParentRoleId = ParentRoleId;
        this.RoleTypeName = RoleTypeName;
        this.RoleValue = RoleValue;
    }
}

export function Models_Body$reflection() {
    return record_type("WebApi.Models.Body", [], Models_Body, () => [["Hidden", bool_type], ["Name", string_type], ["ParentRoleId", class_type("System.Int64")], ["RoleTypeName", string_type], ["RoleValue", string_type]]);
}

export class Models_CsrfDTO extends Record {
    constructor(csrfToken) {
        super();
        this.csrfToken = csrfToken;
    }
}

export function Models_CsrfDTO$reflection() {
    return record_type("WebApi.Models.CsrfDTO", [], Models_CsrfDTO, () => [["csrfToken", string_type]]);
}

export class Models_Feature extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function Models_Feature$reflection() {
    return record_type("WebApi.Models.Feature", [], Models_Feature, () => [["Name", string_type]]);
}

export class Models_FeatureSet extends Record {
    constructor(enable) {
        super();
        this.enable = enable;
    }
}

export function Models_FeatureSet$reflection() {
    return record_type("WebApi.Models.FeatureSet", [], Models_FeatureSet, () => [["enable", bool_type]]);
}

export class Models_InvoiceeAddressChange extends Record {
    constructor(ActiveFrom, ActiveTo, PostalAttention, PostalCity, PostalCode, PostalCountryCode, PostalStreetAddress, UpdatedSwedish) {
        super();
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.PostalAttention = PostalAttention;
        this.PostalCity = PostalCity;
        this.PostalCode = PostalCode;
        this.PostalCountryCode = PostalCountryCode;
        this.PostalStreetAddress = PostalStreetAddress;
        this.UpdatedSwedish = UpdatedSwedish;
    }
}

export function Models_InvoiceeAddressChange$reflection() {
    return record_type("WebApi.Models.InvoiceeAddressChange", [], Models_InvoiceeAddressChange, () => [["ActiveFrom", class_type("System.DateOnly")], ["ActiveTo", option_type(class_type("System.DateOnly"))], ["PostalAttention", string_type], ["PostalCity", option_type(string_type)], ["PostalCode", string_type], ["PostalCountryCode", string_type], ["PostalStreetAddress", string_type], ["UpdatedSwedish", class_type("System.DateTimeOffset")]]);
}

export class Models_InvoiceeBlock extends Record {
    constructor(AtUtc, BlockType, Error$, Note) {
        super();
        this.AtUtc = AtUtc;
        this.BlockType = BlockType;
        this.Error = Error$;
        this.Note = Note;
    }
}

export function Models_InvoiceeBlock$reflection() {
    return record_type("WebApi.Models.InvoiceeBlock", [], Models_InvoiceeBlock, () => [["AtUtc", class_type("System.DateTimeOffset")], ["BlockType", string_type], ["Error", string_type], ["Note", string_type]]);
}

export class Models_InvoiceeChange extends Record {
    constructor(AtUtc, EventArgs, EventName, UserId, Username) {
        super();
        this.AtUtc = AtUtc;
        this.EventArgs = EventArgs;
        this.EventName = EventName;
        this.UserId = UserId;
        this.Username = Username;
    }
}

export function Models_InvoiceeChange$reflection() {
    return record_type("WebApi.Models.InvoiceeChange", [], Models_InvoiceeChange, () => [["AtUtc", class_type("System.DateTimeOffset")], ["EventArgs", list_type(Models_ValueChange$reflection())], ["EventName", string_type], ["UserId", class_type("System.Int64")], ["Username", string_type]]);
}

export class Models_InvoiceeHistory extends Record {
    constructor(AddressChanges, InvoiceeChanges) {
        super();
        this.AddressChanges = AddressChanges;
        this.InvoiceeChanges = InvoiceeChanges;
    }
}

export function Models_InvoiceeHistory$reflection() {
    return record_type("WebApi.Models.InvoiceeHistory", [], Models_InvoiceeHistory, () => [["AddressChanges", list_type(Models_InvoiceeAddressChange$reflection())], ["InvoiceeChanges", list_type(Models_InvoiceeChange$reflection())]]);
}

export class Models_LoginInputDTO extends Record {
    constructor(password, username) {
        super();
        this.password = password;
        this.username = username;
    }
}

export function Models_LoginInputDTO$reflection() {
    return record_type("WebApi.Models.LoginInputDTO", [], Models_LoginInputDTO, () => [["password", string_type], ["username", string_type]]);
}

export class Models_LoginOtpInputDTO extends Record {
    constructor(otp, username) {
        super();
        this.otp = otp;
        this.username = username;
    }
}

export function Models_LoginOtpInputDTO$reflection() {
    return record_type("WebApi.Models.LoginOtpInputDTO", [], Models_LoginOtpInputDTO, () => [["otp", string_type], ["username", string_type]]);
}

export class Models_LoginOtpOutputDTO extends Record {
    constructor(message, success) {
        super();
        this.message = message;
        this.success = success;
    }
}

export function Models_LoginOtpOutputDTO$reflection() {
    return record_type("WebApi.Models.LoginOtpOutputDTO", [], Models_LoginOtpOutputDTO, () => [["message", string_type], ["success", bool_type]]);
}

export class Models_LoginOutputDTO extends Record {
    constructor(message, requiresOtp, success) {
        super();
        this.message = message;
        this.requiresOtp = requiresOtp;
        this.success = success;
    }
}

export function Models_LoginOutputDTO$reflection() {
    return record_type("WebApi.Models.LoginOutputDTO", [], Models_LoginOutputDTO, () => [["message", string_type], ["requiresOtp", bool_type], ["success", bool_type]]);
}

export class Models_PrincipalPrivilegeDTO extends Record {
    constructor(AggregatedResource, AggregatedRole, GroupName, GroupPrincipalId, IpRegex, RoleName) {
        super();
        this.AggregatedResource = AggregatedResource;
        this.AggregatedRole = AggregatedRole;
        this.GroupName = GroupName;
        this.GroupPrincipalId = GroupPrincipalId;
        this.IpRegex = IpRegex;
        this.RoleName = RoleName;
    }
}

export function Models_PrincipalPrivilegeDTO$reflection() {
    return record_type("WebApi.Models.PrincipalPrivilegeDTO", [], Models_PrincipalPrivilegeDTO, () => [["AggregatedResource", string_type], ["AggregatedRole", string_type], ["GroupName", option_type(string_type)], ["GroupPrincipalId", option_type(class_type("System.Int64"))], ["IpRegex", option_type(string_type)], ["RoleName", string_type]]);
}

export class Models_PrincipalPrivilegeDTO$002Ddot$002DRecord extends Record {
    constructor(AggregatedResource, AggregatedRole, GroupName, GroupPrincipalId, IpRegex, RoleName) {
        super();
        this.AggregatedResource = AggregatedResource;
        this.AggregatedRole = AggregatedRole;
        this.GroupName = GroupName;
        this.GroupPrincipalId = GroupPrincipalId;
        this.IpRegex = IpRegex;
        this.RoleName = RoleName;
    }
}

export function Models_PrincipalPrivilegeDTO$002Ddot$002DRecord$reflection() {
    return record_type("WebApi.Models.PrincipalPrivilegeDTO-dot-Record", [], Models_PrincipalPrivilegeDTO$002Ddot$002DRecord, () => [["AggregatedResource", string_type], ["AggregatedRole", string_type], ["GroupName", string_type], ["GroupPrincipalId", option_type(class_type("System.Int64"))], ["IpRegex", option_type(class_type("System.Int64"))], ["RoleName", string_type]]);
}

export class Models_PrivilegeDto extends Record {
    constructor(Resource, ResourceId, ResourceName, Role, RoleId, RoleName, RoleValue) {
        super();
        this.Resource = Resource;
        this.ResourceId = ResourceId;
        this.ResourceName = ResourceName;
        this.Role = Role;
        this.RoleId = RoleId;
        this.RoleName = RoleName;
        this.RoleValue = RoleValue;
    }
}

export function Models_PrivilegeDto$reflection() {
    return record_type("WebApi.Models.PrivilegeDto", [], Models_PrivilegeDto, () => [["Resource", option_type(string_type)], ["ResourceId", option_type(class_type("System.Int64"))], ["ResourceName", option_type(string_type)], ["Role", option_type(string_type)], ["RoleId", option_type(class_type("System.Int64"))], ["RoleName", option_type(string_type)], ["RoleValue", option_type(string_type)]]);
}

export class Models_Record extends Record {
    constructor(Amount, BlockedStatus, DueDate, MortgageInvoiceId, PaidAmount, RemainingAmount) {
        super();
        this.Amount = Amount;
        this.BlockedStatus = BlockedStatus;
        this.DueDate = DueDate;
        this.MortgageInvoiceId = MortgageInvoiceId;
        this.PaidAmount = PaidAmount;
        this.RemainingAmount = RemainingAmount;
    }
}

export function Models_Record$reflection() {
    return record_type("WebApi.Models.Record", [], Models_Record, () => [["Amount", class_type("System.Decimal")], ["BlockedStatus", class_type("System.Int64")], ["DueDate", class_type("System.DateOnly")], ["MortgageInvoiceId", class_type("System.Int64")], ["PaidAmount", class_type("System.Decimal")], ["RemainingAmount", option_type(class_type("System.Decimal"))]]);
}

export class Models_SecondaryRoleDto extends Record {
    constructor(Privilege) {
        super();
        this.Privilege = Privilege;
    }
}

export function Models_SecondaryRoleDto$reflection() {
    return record_type("WebApi.Models.SecondaryRoleDto", [], Models_SecondaryRoleDto, () => [["Privilege", list_type(Models_PrivilegeDto$reflection())]]);
}

export class Models_SentEmail extends Record {
    constructor(EmailBody, EmailSentId, EmailSubject, FromEmail, SentAtSwedish, ToEmail) {
        super();
        this.EmailBody = EmailBody;
        this.EmailSentId = EmailSentId;
        this.EmailSubject = EmailSubject;
        this.FromEmail = FromEmail;
        this.SentAtSwedish = SentAtSwedish;
        this.ToEmail = ToEmail;
    }
}

export function Models_SentEmail$reflection() {
    return record_type("WebApi.Models.SentEmail", [], Models_SentEmail, () => [["EmailBody", string_type], ["EmailSentId", class_type("System.Int64")], ["EmailSubject", string_type], ["FromEmail", option_type(string_type)], ["SentAtSwedish", class_type("System.DateTimeOffset")], ["ToEmail", string_type]]);
}

export class Models_SentSms extends Record {
    constructor(deliveryStatus, phonenumber, sentAtUtc, text) {
        super();
        this.deliveryStatus = deliveryStatus;
        this.phonenumber = phonenumber;
        this.sentAtUtc = sentAtUtc;
        this.text = text;
    }
}

export function Models_SentSms$reflection() {
    return record_type("WebApi.Models.SentSms", [], Models_SentSms, () => [["deliveryStatus", string_type], ["phonenumber", string_type], ["sentAtUtc", class_type("System.DateTimeOffset")], ["text", string_type]]);
}

export class Models_ValueChange extends Record {
    constructor(Field, NewValue, OldValue, Type) {
        super();
        this.Field = Field;
        this.NewValue = NewValue;
        this.OldValue = OldValue;
        this.Type = Type;
    }
}

export function Models_ValueChange$reflection() {
    return record_type("WebApi.Models.ValueChange", [], Models_ValueChange, () => [["Field", string_type], ["NewValue", string_type], ["OldValue", string_type], ["Type", string_type]]);
}

export class Models_impersonateDTO extends Record {
    constructor(principalId) {
        super();
        this.principalId = principalId;
    }
}

export function Models_impersonateDTO$reflection() {
    return record_type("WebApi.Models.impersonateDTO", [], Models_impersonateDTO, () => [["principalId", class_type("System.Int64")]]);
}

export class Models_updateIpWhiteListDTO extends Record {
    constructor(ipWhiteList) {
        super();
        this.ipWhiteList = ipWhiteList;
    }
}

export function Models_updateIpWhiteListDTO$reflection() {
    return record_type("WebApi.Models.updateIpWhiteListDTO", [], Models_updateIpWhiteListDTO, () => [["ipWhiteList", list_type(string_type)]]);
}

export function Models_AdmittanceAndFenixUserModule_ReadTextJson(node) {
    let node_2;
    return new Models_AdmittanceAndFenixUser(Models_AdmittanceUserDtoModule_ReadTextJson(SveaDry_Read_prop(true, "AdmittanceUser", node)), (node_2 = SveaDry_Read_prop(true, "FenixUser", node), {
        AdmittanceLoginEnabled: SveaDry_Read_boolean(SveaDry_Read_prop(true, "AdmittanceLoginEnabled", node_2)),
        Email: SveaDry_Read_string(SveaDry_Read_prop(true, "Email", node_2)),
        IpWhiteList: SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "IpWhiteList", node_2)),
        IsApi: SveaDry_Read_boolean(SveaDry_Read_prop(true, "IsApi", node_2)),
        MfaMethod: SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "MfaMethod", node_2)),
        Name: SveaDry_Read_string(SveaDry_Read_prop(true, "Name", node_2)),
        RequireIdsStepUp: SveaDry_Read_boolean(SveaDry_Read_prop(true, "RequireIdsStepUp", node_2)),
        UserId: SveaDry_Read_int64(SveaDry_Read_prop(true, "UserId", node_2)),
        Username: SveaDry_Read_string(SveaDry_Read_prop(true, "Username", node_2)),
    }));
}

export function Models_AdmittanceFenixUserModule_ReadTextJson(node) {
    return new Models_AdmittanceFenixUser(SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "AccountType", node)), SveaDry_Read_boolean(SveaDry_Read_prop(true, "AdmittanceLoginEnabled", node)), SveaDry_Read_optional((arg) => Format_dateTime(SveaDry_Read_string(arg)), SveaDry_Read_prop(false, "CreatedDateSwedish", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Email", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "IpWhiteList", node)), SveaDry_Read_boolean(SveaDry_Read_prop(true, "IsApi", node)), SveaDry_Read_optional((arg_1) => Format_dateTime(SveaDry_Read_string(arg_1)), SveaDry_Read_prop(false, "LastLoginSwedish", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "MfaMethod", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "MobileNo", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Name", node)), SveaDry_Read_boolean(SveaDry_Read_prop(true, "RequireIdsStepUp", node)), SveaDry_Read_int64(SveaDry_Read_prop(true, "UserId", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Username", node)));
}

export function Models_AdmittanceUserModule_WriteTextJson(item) {
    return SveaDry_Write_object([["AdmittanceEnabled", SveaDry_Write_boolean(item.AdmittanceEnabled)], ["IsApi", SveaDry_Write_boolean(item.IsApi)], ["Otp", SveaDry_Write_boolean(item.Otp)], ["RequireStepUp", SveaDry_Write_boolean(item.RequireStepUp)]]);
}

export function Models_AdmittanceUserDtoModule_ReadTextJson(node) {
    return new Models_AdmittanceUserDto(SveaDry_Read_string(SveaDry_Read_prop(true, "AccountType", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "CreatedTime", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Email", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "LastLogin", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "LoginName", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "MobileNo", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Name", node)), SveaDry_Read_int64(SveaDry_Read_prop(true, "PrincipalId", node)), SveaDry_Read_array(Models_SecondaryRoleDtoModule_ReadTextJson, SveaDry_Read_prop(true, "SecondaryRoles", node)));
}

export function Models_BillingForClientModule_ReadTextJson(node) {
    return new Models_BillingForClient(SveaDry_Read_boolean(SveaDry_Read_prop(true, "Acceptable", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "AcceptedBy", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Batch", node)), SveaDry_Read_int64(SveaDry_Read_prop(true, "BatchId", node)), SveaDry_Read_boolean(SveaDry_Read_prop(true, "CanRollback", node)), SveaDry_Read_optional(SveaDry_Read_int64, SveaDry_Read_prop(false, "ElapsedSeconds", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Initiated", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "InitiatedBy", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "InitiatedUtc", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "InitiationKey", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "RollbackedBy", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "Started", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "StartedUtc", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "State", node)), SveaDry_Read_int64(SveaDry_Read_prop(true, "StatusCode", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "StatusDateTime", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "StatusMessage", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "StatusUtc", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Type", node)));
}

export function Models_BodyModule_WriteTextJson(item) {
    return SveaDry_Write_object([["Hidden", SveaDry_Write_boolean(item.Hidden)], ["Name", SveaDry_Write_string(item.Name)], ["ParentRoleId", SveaDry_Write_int64(item.ParentRoleId)], ["RoleTypeName", SveaDry_Write_string(item.RoleTypeName)], ["RoleValue", SveaDry_Write_string(item.RoleValue)]]);
}

export function Models_CsrfDTOModule_ReadTextJson(node) {
    return new Models_CsrfDTO(SveaDry_Read_string(SveaDry_Read_prop(true, "csrfToken", node)));
}

export function Models_FeatureModule_ReadTextJson(node) {
    return new Models_Feature(SveaDry_Read_string(SveaDry_Read_prop(true, "Name", node)));
}

export function Models_FeatureSetModule_WriteTextJson(item) {
    return SveaDry_Write_object([["enable", SveaDry_Write_boolean(item.enable)]]);
}

export function Models_InvoiceeAddressChangeModule_ReadTextJson(node) {
    return new Models_InvoiceeAddressChange(Format_date(SveaDry_Read_string(SveaDry_Read_prop(true, "ActiveFrom", node))), SveaDry_Read_optional((arg_1) => Format_date(SveaDry_Read_string(arg_1)), SveaDry_Read_prop(false, "ActiveTo", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "PostalAttention", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "PostalCity", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "PostalCode", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "PostalCountryCode", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "PostalStreetAddress", node)), Format_dateTime(SveaDry_Read_string(SveaDry_Read_prop(true, "UpdatedSwedish", node))));
}

export function Models_InvoiceeBlockModule_ReadTextJson(node) {
    return new Models_InvoiceeBlock(Format_dateTime(SveaDry_Read_string(SveaDry_Read_prop(true, "AtUtc", node))), SveaDry_Read_string(SveaDry_Read_prop(true, "BlockType", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Error", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Note", node)));
}

export function Models_InvoiceeChangeModule_ReadTextJson(node) {
    return new Models_InvoiceeChange(Format_dateTime(SveaDry_Read_string(SveaDry_Read_prop(true, "AtUtc", node))), SveaDry_Read_array(Models_ValueChangeModule_ReadTextJson, SveaDry_Read_prop(true, "EventArgs", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "EventName", node)), SveaDry_Read_int64(SveaDry_Read_prop(true, "UserId", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Username", node)));
}

export function Models_InvoiceeHistoryModule_ReadTextJson(node) {
    return new Models_InvoiceeHistory(SveaDry_Read_array(Models_InvoiceeAddressChangeModule_ReadTextJson, SveaDry_Read_prop(true, "AddressChanges", node)), SveaDry_Read_array(Models_InvoiceeChangeModule_ReadTextJson, SveaDry_Read_prop(true, "InvoiceeChanges", node)));
}

export function Models_LoginInputDTOModule_WriteTextJson(item) {
    return SveaDry_Write_object([["password", SveaDry_Write_string(item.password)], ["username", SveaDry_Write_string(item.username)]]);
}

export function Models_LoginOtpInputDTOModule_WriteTextJson(item) {
    return SveaDry_Write_object([["otp", SveaDry_Write_string(item.otp)], ["username", SveaDry_Write_string(item.username)]]);
}

export function Models_LoginOtpOutputDTOModule_ReadTextJson(node) {
    return new Models_LoginOtpOutputDTO(SveaDry_Read_string(SveaDry_Read_prop(true, "message", node)), SveaDry_Read_boolean(SveaDry_Read_prop(true, "success", node)));
}

export function Models_LoginOutputDTOModule_ReadTextJson(node) {
    return new Models_LoginOutputDTO(SveaDry_Read_string(SveaDry_Read_prop(true, "message", node)), SveaDry_Read_boolean(SveaDry_Read_prop(true, "requiresOtp", node)), SveaDry_Read_boolean(SveaDry_Read_prop(true, "success", node)));
}

export function Models_PrincipalPrivilegeDTOModule_ReadTextJson(node) {
    return new Models_PrincipalPrivilegeDTO(SveaDry_Read_string(SveaDry_Read_prop(true, "AggregatedResource", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "AggregatedRole", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "GroupName", node)), SveaDry_Read_optional(SveaDry_Read_int64, SveaDry_Read_prop(false, "GroupPrincipalId", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "IpRegex", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "RoleName", node)));
}

export function Models_PrincipalPrivilegeDTO$002Ddot$002DRecordModule_ReadTextJson(node) {
    return new Models_PrincipalPrivilegeDTO$002Ddot$002DRecord(SveaDry_Read_string(SveaDry_Read_prop(true, "AggregatedResource", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "AggregatedRole", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "GroupName", node)), SveaDry_Read_optional(SveaDry_Read_int64, SveaDry_Read_prop(false, "GroupPrincipalId", node)), SveaDry_Read_optional(SveaDry_Read_int64, SveaDry_Read_prop(false, "IpRegex", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "RoleName", node)));
}

export function Models_PrivilegeDtoModule_ReadTextJson(node) {
    return new Models_PrivilegeDto(SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "Resource", node)), SveaDry_Read_optional(SveaDry_Read_int64, SveaDry_Read_prop(false, "ResourceId", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "ResourceName", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "Role", node)), SveaDry_Read_optional(SveaDry_Read_int64, SveaDry_Read_prop(false, "RoleId", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "RoleName", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "RoleValue", node)));
}

export function Models_RecordModule_ReadTextJson(node) {
    return new Models_Record(SveaDry_Read_decimal(SveaDry_Read_prop(true, "Amount", node)), SveaDry_Read_int64(SveaDry_Read_prop(true, "BlockedStatus", node)), Format_date(SveaDry_Read_string(SveaDry_Read_prop(true, "DueDate", node))), SveaDry_Read_int64(SveaDry_Read_prop(true, "MortgageInvoiceId", node)), SveaDry_Read_decimal(SveaDry_Read_prop(true, "PaidAmount", node)), SveaDry_Read_optional(SveaDry_Read_decimal, SveaDry_Read_prop(false, "RemainingAmount", node)));
}

export function Models_RecordModule_WriteTextJson(item) {
    return SveaDry_Write_object([["Amount", SveaDry_Write_decimal(item.Amount)], ["BlockedStatus", SveaDry_Write_int64(item.BlockedStatus)], ["DueDate", SveaDry_Write_string(Unformat_date(item.DueDate))], ["MortgageInvoiceId", SveaDry_Write_int64(item.MortgageInvoiceId)], ["PaidAmount", SveaDry_Write_decimal(item.PaidAmount)], ["RemainingAmount", SveaDry_Write_optional(SveaDry_Write_decimal, item.RemainingAmount)]]);
}

export function Models_SecondaryRoleDtoModule_ReadTextJson(node) {
    return new Models_SecondaryRoleDto(SveaDry_Read_array(Models_PrivilegeDtoModule_ReadTextJson, SveaDry_Read_prop(true, "Privilege", node)));
}

export function Models_SentEmailModule_ReadTextJson(node) {
    return new Models_SentEmail(SveaDry_Read_string(SveaDry_Read_prop(true, "EmailBody", node)), SveaDry_Read_int64(SveaDry_Read_prop(true, "EmailSentId", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "EmailSubject", node)), SveaDry_Read_optional(SveaDry_Read_string, SveaDry_Read_prop(false, "FromEmail", node)), Format_dateTime(SveaDry_Read_string(SveaDry_Read_prop(true, "SentAtSwedish", node))), SveaDry_Read_string(SveaDry_Read_prop(true, "ToEmail", node)));
}

export function Models_SentSmsModule_ReadTextJson(node) {
    return new Models_SentSms(SveaDry_Read_string(SveaDry_Read_prop(true, "deliveryStatus", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "phonenumber", node)), Format_dateTime(SveaDry_Read_string(SveaDry_Read_prop(true, "sentAtUtc", node))), SveaDry_Read_string(SveaDry_Read_prop(true, "text", node)));
}

export function Models_ValueChangeModule_ReadTextJson(node) {
    return new Models_ValueChange(SveaDry_Read_string(SveaDry_Read_prop(true, "Field", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "NewValue", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "OldValue", node)), SveaDry_Read_string(SveaDry_Read_prop(true, "Type", node)));
}

export function Models_impersonateDTOModule_WriteTextJson(item) {
    return SveaDry_Write_object([["principalId", SveaDry_Write_int64(item.principalId)]]);
}

export function Models_updateIpWhiteListDTOModule_WriteTextJson(item) {
    return SveaDry_Write_object([["ipWhiteList", SveaDry_Write_array(SveaDry_Write_string, item.ipWhiteList)]]);
}

export class Results_Response extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Code400"];
    }
}

export function Results_Response$reflection() {
    return union_type("WebApi.Results.Response", [], Results_Response, () => [[["Item", string_type]]]);
}

export function Results_ResponseModule_ReadTextJson(response) {
    const matchValue = SveaDry_ResponseContainer__get_StatusCode(response.ResponseContainer) | 0;
    if (matchValue === 400) {
        return new Results_Response(0, SveaDry_Read_string(response));
    }
    else {
        const arg_2 = SveaDry_ResponseContainer__get_AsString(response.ResponseContainer);
        return toFail(printf("Unknown ResponseStatus received %i, Body:\r\n%s"))(matchValue)(arg_2);
    }
}

export function Results_Response1Module_ReadTextJson(response) {
    const matchValue = SveaDry_ResponseContainer__get_StatusCode(response.ResponseContainer) | 0;
    if (matchValue === 200) {
        SveaDry_Read_unit(response);
    }
    else {
        const arg_1 = SveaDry_ResponseContainer__get_AsString(response.ResponseContainer);
        toFail(printf("Unknown ResponseStatus received %i, Body:\r\n%s"))(matchValue)(arg_1);
    }
}

export class Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002D extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Code401", "Code400", "Code302"];
    }
}

export function Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002D$reflection() {
    return union_type("WebApi.Results.AlternativeResponsePOST--slash-admittance-slash-impersonate-slash-", [], Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002D, () => [[["Item", string_type]], [["Item", string_type]], [["Item", unit_type]]]);
}

export function Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002DModule_ReadTextJson(response) {
    const matchValue = SveaDry_ResponseContainer__get_StatusCode(response.ResponseContainer) | 0;
    switch (matchValue) {
        case 302: {
            const arg_2 = SveaDry_Read_unit(response);
            return new Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002D(2, void 0);
        }
        case 400: {
            return new Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002D(1, SveaDry_Read_string(response));
        }
        case 401: {
            return new Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002D(0, SveaDry_Read_string(response));
        }
        default: {
            const arg_4 = SveaDry_ResponseContainer__get_AsString(response.ResponseContainer);
            return toFail(printf("Unknown ResponseStatus received %i, Body:\r\n%s"))(matchValue)(arg_4);
        }
    }
}

export function Admittance_POST$002D$002Fadmittance$002FprincipalId$002Fuser$002F$002DAsync(dep, principalId, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "POST", empty(), templateUrl("/admittance/{principalId}/user/", [["principalId", Required_AsString_Z524259C1(principalId)]], []), Models_AdmittanceUserModule_WriteTextJson(body)), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_int64(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_GET$002D$002Fadmittance$002FprincipalId$002Fprincipalprivileges$002F$002DAsync(dep, principalId) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/admittance/{principalId}/principalprivileges/", [["principalId", Required_AsString_Z524259C1(principalId)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_PrincipalPrivilegeDTO$002Ddot$002DRecordModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_PUT$002D$002Fadmittance$002FprincipalId$002Fipwhitelist$002F$002DAsync(dep, principalId, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "PUT", empty(), templateUrl("/admittance/{principalId}/ipwhitelist/", [["principalId", Required_AsString_Z524259C1(principalId)]], []), Models_updateIpWhiteListDTOModule_WriteTextJson(body)), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_int64(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_GET$002D$002Fadmittance$002FclientNr$002F$002DAsync(dep, clientNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/admittance/{clientNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_AdmittanceFenixUserModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_POST$002D$002Fadmittance$002Fimpersonate$002F$002DAsync(dep, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "POST", empty(), templateUrl("/admittance/impersonate/", [], []), Models_impersonateDTOModule_WriteTextJson(body)), (_arg) => {
        let arg_1;
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? ((arg_1 = SveaDry_Read_unit(SveaDry_Read_load(response)), new FSharpResult$2(0, void 0))) : (new FSharpResult$2(1, Results_AlternativeResponsePOST$002D$002Dslash$002Dadmittance$002Dslash$002Dimpersonate$002Dslash$002DModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_GET$002D$002FData$002FAdmittance$002FclientNr$002FinvoiceeNr$002F$002DAsync(dep, clientNr, invoiceeNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/Data/Admittance/{clientNr}/{invoiceeNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["invoiceeNr", Required_AsString_Z524259C1(invoiceeNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_AdmittanceUserDtoModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_GET$002D$002FData$002FAdmittance$002FclientNr$002FPrincipalPrivileges$002FprincipalId$002F$002DAsync(dep, clientNr, principalId) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/Data/Admittance/{clientNr}/PrincipalPrivileges/{principalId}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["principalId", Required_AsString_Z721C83C5(principalId)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_PrincipalPrivilegeDTOModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_GET$002D$002FData$002FAdmittance$002FclientNr$002F$002DAsync(dep, clientNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/Data/Admittance/{clientNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_AdmittanceAndFenixUserModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_POST$002D$002FData$002FAdmittance$002FRole$002FNew$002F$002DAsync(dep, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "POST", empty(), templateUrl("/Data/Admittance/Role/New/", [], []), Models_BodyModule_WriteTextJson(body)), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_string(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Admittance_GET$002D$002FData$002FAdmittance$002F$002DAsync(dep) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/Data/Admittance/", [], []), void 0), (_arg) => singleton.Return(Results_Response1Module_ReadTextJson(SveaDry_Read_load(_arg)))));
}

export function Billing_GET$002D$002FData$002FBillings$002FclientNr$002F$002DAsync(dep, clientNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/Data/Billings/{clientNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_BillingForClientModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function ClientDetails_PUT$002D$002FclientDetails$002FclientNr$002F$002DAsync(dep, clientNr, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "PUT", empty(), templateUrl("/clientDetails/{clientNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)]], []), Models_RecordModule_WriteTextJson(body)), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_int64(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function ClientDetails_GET$002D$002FclientDetails$002FclientNr$002F$002DAsync(dep, clientNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/clientDetails/{clientNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, Models_RecordModule_ReadTextJson(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Feature_PUT$002D$002Ffeature$002FfeatureName$002F$002DAsync(dep, featureName, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "PUT", empty(), templateUrl("/feature/{featureName}/", [["featureName", Required_AsString_Z721C83C5(featureName)]], []), Models_FeatureSetModule_WriteTextJson(body)), (_arg) => {
        let arg_1;
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? ((arg_1 = SveaDry_Read_unit(SveaDry_Read_load(response)), new FSharpResult$2(0, void 0))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Feature_GET$002D$002Ffeature$002F$002DAsync(dep) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/feature/", [], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_FeatureModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function History_GET$002D$002Fhistory$002FsentSms$002FclientNr$002FinvoiceeNr$002F$002DAsync(dep, clientNr, invoiceeNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/history/sentSms/{clientNr}/{invoiceeNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["invoiceeNr", Required_AsString_Z524259C1(invoiceeNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_SentSmsModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function History_GET$002D$002Fhistory$002FsentEmail$002FclientNr$002FinvoiceeNr$002F$002DAsync(dep, clientNr, invoiceeNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/history/sentEmail/{clientNr}/{invoiceeNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["invoiceeNr", Required_AsString_Z524259C1(invoiceeNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_SentEmailModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function History_GET$002D$002FHistory$002FInvoicee$002FclientNr$002FinvoiceeNr$002F$002DAsync(dep, clientNr, invoiceeNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/History/Invoicee/{clientNr}/{invoiceeNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["invoiceeNr", Required_AsString_Z524259C1(invoiceeNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, Models_InvoiceeHistoryModule_ReadTextJson(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Invoicee_GET$002D$002FInvoicee$002FBlock$002FclientNr$002FinvoiceeNr$002F$002DAsync(dep, clientNr, invoiceeNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/Invoicee/Block/{clientNr}/{invoiceeNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["invoiceeNr", Required_AsString_Z524259C1(invoiceeNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_InvoiceeBlockModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Login_GET$002D$002Fauth$002Fsso$002DAsync(dep) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/auth/sso", [], []), void 0), (_arg) => singleton.Return(Results_Response1Module_ReadTextJson(SveaDry_Read_load(_arg)))));
}

export function Login_GET$002D$002Fauth$002Flogout$002DAsync(dep) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/auth/logout", [], []), void 0), (_arg) => singleton.Return(Results_Response1Module_ReadTextJson(SveaDry_Read_load(_arg)))));
}

export function Login_POST$002D$002Fauth$002Flogin$002Fotp$002F$002DAsync(dep, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "POST", empty(), templateUrl("/auth/login/otp/", [], []), Models_LoginOtpInputDTOModule_WriteTextJson(body)), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, Models_LoginOtpOutputDTOModule_ReadTextJson(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Login_POST$002D$002Fauth$002Flogin$002F$002DAsync(dep, body) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "POST", empty(), templateUrl("/auth/login/", [], []), Models_LoginInputDTOModule_WriteTextJson(body)), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, Models_LoginOutputDTOModule_ReadTextJson(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Login_GET$002D$002Fauth$002Finit$002Dsession$002DAsync(dep) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/auth/init-session", [], []), void 0), (_arg) => singleton.Return(Results_Response1Module_ReadTextJson(SveaDry_Read_load(_arg)))));
}

export function Login_GET$002D$002Fauth$002Fcsrf$002Dtoken$002F$002DAsync(dep) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/auth/csrf-token/", [], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, Models_CsrfDTOModule_ReadTextJson(SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Login_GET$002D$002Fauth$002Fcallback$002DAsync(dep) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/auth/callback", [], []), void 0), (_arg) => singleton.Return(Results_Response1Module_ReadTextJson(SveaDry_Read_load(_arg)))));
}

export function Mortgage_GET$002D$002Fmortgage$002Finvoice$002FclientNr$002FcontractNr$002F$002DAsync(dep, clientNr, contractNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/mortgage/invoice/{clientNr}/{contractNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["contractNr", Required_AsString_Z524259C1(contractNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_RecordModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Mortgage_GET$002D$002Fmortgage$002FhistoricalMortgageValue$002FclientNr$002FcontractNr$002F$002DAsync(dep, clientNr, contractNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/mortgage/historicalMortgageValue/{clientNr}/{contractNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["contractNr", Required_AsString_Z524259C1(contractNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_RecordModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

export function Mortgage_GET$002D$002Fmortgage$002FcurrentMortgageValue$002FclientNr$002FcontractNr$002F$002DAsync(dep, clientNr, contractNr) {
    return singleton.Delay(() => singleton.Bind(SveaDry_sendAsync(dep, "GET", empty(), templateUrl("/mortgage/currentMortgageValue/{clientNr}/{contractNr}/", [["clientNr", Required_AsString_Z524259C1(clientNr)], ["contractNr", Required_AsString_Z524259C1(contractNr)]], []), void 0), (_arg) => {
        const response = _arg;
        return singleton.Return((SveaDry_ResponseContainer__get_StatusCode(response) === 200) ? (new FSharpResult$2(0, SveaDry_Read_array(Models_RecordModule_ReadTextJson, SveaDry_Read_load(response)))) : (new FSharpResult$2(1, Results_ResponseModule_ReadTextJson(SveaDry_Read_load(response)))));
    }));
}

